import { Box, useMediaQuery } from "@material-ui/core"
import { productViewBreakpoint } from "../../../lib/helper/viewportHelper"
import theme from "../../../theme"
import ProductCard from "../../Products/ProductCard/ProductCard"
import { persistScrollPosition } from "../helperFunctions"
import useStyles from "../styles"
import React from "react"

const ComparisonHeader = ({ products }) => {
    const classes = useStyles()
    const isMobile = useMediaQuery(theme.breakpoints.down(productViewBreakpoint))

    return (
        <Box className={classes.comparisonHeader}>
            {
                products.map(product => {
                    return (
                        <Box style={{ padding: isMobile ? 0 : 8 }}>
                            <ProductCard
                                product={product}
                                handleShowMoreCompsClick={null}
                                listView={true}
                                grid={true}
                                onSelect={persistScrollPosition}
                                compare={true}
                            />
                        </Box>
                    )
                })
            }
        </Box>
    )
}

export default ComparisonHeader